import React, { useState } from "react"

import { Translate } from "../../Components/Translator"
import { ZendeskGetAutoExecuteOnState, ZendeskGetAutoActionOneMatch, ZendeskGetAutoActionNoMatch, ZendeskSetAutoActionOneMatch, ZendeskSetAutoActionNoMatch, ZendeskGetTicketInboundCallBody, ZendeskGetTicketInboundCallSubject, ZendeskGetTicketOutboundCallBody, ZendeskGetTicketOutboundCallSubject, 
    ZendeskGetTicketInboundCallBrandPerDdi, ZendeskGetTicketInboundCallGroupPerDdi, ZendeskGetTicketInboundCallTagPerDdi, 
    ZendeskGetTicketOutboundCallTag, ZendeskSetAutoExecuteOnState, ZendeskSetTicketInboundCallSubject, ZendeskSetTicketInboundCallBody, 
    ZendeskSetTicketOutboundCallBody, ZendeskSetTicketOutboundCallSubject,
    ZendeskSetTicketInboundCallBrandPerDdi, ZendeskSetTicketInboundCallGroupPerDdi, ZendeskSetTicketInboundCallTagPerDdi, 
    ZendeskSetTicketOutboundCallTag } from "./EmbeddedZendeskSupport.jsx"

const EmbeddedZendeskSettings = (props) => {

    const [mRepainter, SetRepainter] = useState(0)

    const SetAutoExecuteOnState = (value) => {
        ZendeskSetAutoExecuteOnState(value)
        SetRepainter(mRepainter + 1)
    }

    const SetAutoActionNoMatch = (value) => {
        ZendeskSetAutoActionNoMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetAutoActionOneMatch = (value) => {
        ZendeskSetAutoActionOneMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketInboundCallBody = (value) => {
        ZendeskSetTicketInboundCallBody(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketInboundCallSubject = (value) => {
        ZendeskSetTicketInboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketOutboundCallBody = (value) => {
        ZendeskSetTicketOutboundCallBody(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketOutboundCallSubject = (value) => {
        ZendeskSetTicketOutboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketInboundCallBrandPerDdi = (value) => {
        ZendeskSetTicketInboundCallBrandPerDdi(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketInboundCallGroupPerDdi = (value) => {
        ZendeskSetTicketInboundCallGroupPerDdi(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketInboundCallTagPerDdi = (value) => {
        ZendeskSetTicketInboundCallTagPerDdi(value)
        SetRepainter(mRepainter + 1)
    }

    const SetTicketOutboundCallTag = (value) => {
        ZendeskSetTicketOutboundCallTag(value)
        SetRepainter(mRepainter + 1)
    }

    const LocalStorageSettingShowState = localStorage.getItem("zendesk_setting_autoexecuteonstate")
    const SettingShowState = LocalStorageSettingShowState === "answered" ? "answered" : (LocalStorageSettingShowState === "ended" ? "ended" : "started")

    const settingautoactiononematch = ZendeskGetAutoActionOneMatch()
    const settingautoactionnomatch = ZendeskGetAutoActionNoMatch()

    return (
        <>
            <tr className="usersettings" height="20"/>
            <tr className="foregroundlightasbackground">
                <td colSpan="2" align="center"><b>Zendesk</b></td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Automatic actions")}</td>
                <td width="*" valign="center">
                    {Translate("What actions should be automatically performed?")}<br/>
                    <br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetAutoExecuteOnState(evt.target.value)} value={SettingShowState}>
                        <option value="started">{Translate("When you receive the call")}</option>
                        <option value="answered">{Translate("When you answer the call")}</option>
                        <option value="ended">{Translate("When you end the call")}</option>
                    </select><br/> 
                    <br/>  
                    <b className="smalltext">{Translate("Single-matching Zendesk record")}</b><br/>
                    <div><input type="radio" name="autoonematch" value="" checked={settingautoactiononematch === ""} onChange={(e) => SetAutoActionOneMatch(e.target.value)}/>
                        &nbsp; {Translate("No action")}
                    </div>
                    <div><input type="radio" name="autoonematch" value="showuser" checked={settingautoactiononematch === "showuser"} onChange={(e) => SetAutoActionOneMatch(e.target.value)}/>
                        &nbsp; {Translate("Show user")}
                    </div>
                    <div><input type="radio" name="autoonematch" value="showopenticket" checked={settingautoactiononematch === "showopenticket"} onChange={(e) => SetAutoActionOneMatch(e.target.value)}/>
                        &nbsp; {Translate("Show open ticket if there is only one")}
                    </div>
                    <div><input type="radio" name="autoonematch" value="smarthandling" checked={settingautoactiononematch === "smarthandling"} onChange={(e) => SetAutoActionOneMatch(e.target.value)}/>
                        &nbsp; {Translate("Smart handling")}<br/>
                        — {Translate("No open tickets → create and show new ticket")}<br/>
                        — {Translate("One open ticket → show open ticket")}<br/>
                        — {Translate("Multiple open tickets → show user")}
                    </div>
                    <div><input type="radio" name="autoonematch" value="createandshowticket" checked={settingautoactiononematch === "createandshowticket"} onChange={(e) => SetAutoActionOneMatch(e.target.value)}/>
                        &nbsp; {Translate("Always create new ticket")}
                    </div>

                    <br/>

                    <b className="smalltext">{Translate("No matching Zendesk record")}</b><br/>
                    <div><input type="radio" name="autonomatch" value="" checked={settingautoactionnomatch === ""} onChange={(e) => SetAutoActionNoMatch(e.target.value)}/>
                        &nbsp; {Translate("No action")}
                    </div>
                    <div><input type="radio" name="autonomatch" value="createandshowuser" checked={settingautoactionnomatch === "createandshowuser"} onChange={(e) => SetAutoActionNoMatch(e.target.value)}/>
                        &nbsp; {Translate("Create and show user")}
                    </div>
                    <div><input type="radio" name="autonomatch" value="createandshowuserandticket" checked={settingautoactionnomatch === "createandshowuserandticket"} onChange={(e) => SetAutoActionNoMatch(e.target.value)}/>
                        &nbsp; {Translate("Create user and create and show ticket")}
                    </div>            
                </td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Default ticket for inbound calls")}</td>
                <td width="*" valign="center">
                    {Translate("Subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketInboundCallSubject()} onChange={(evt) => SetTicketInboundCallSubject(evt.target.value)}/><br/>
                    {Translate("Body")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketInboundCallBody()} onChange={(evt) => SetTicketInboundCallBody(evt.target.value)}/><br/>
                    <span className="smallesttext">{Translate("Available callfields") + ": <callid> <number> <name> <extension> <ddi> <ddiname> <callstart> <calltime> <talktime>"}</span><br/>     
                    <br/>
                    {Translate("Tags per DDI")}<br/>
                    <span className="smallesttext">{"format: <ddi>=<tag1>,<tag2>"}</span><br/>
                    <span className="smallesttext">{"* as ddi for default"}</span><br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketInboundCallTagPerDdi()} onChange={(evt) => SetTicketInboundCallTagPerDdi(evt.target.value)}/><br/>
                    <br/>    
                    {Translate("Groups per DDI")}<br/>
                    <span className="smallesttext">{"format: <ddi>=<groupid>"}</span><br/>
                    <span className="smallesttext">{"* as ddi for default"}</span><br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketInboundCallGroupPerDdi()} onChange={(evt) => SetTicketInboundCallGroupPerDdi(evt.target.value)}/><br/>
                    <br/>  
                    {Translate("Brands per DDI")}<br/>
                    <span className="smallesttext">{"format: <ddi>=<brandid>"}</span><br/>
                    <span className="smallesttext">{"* as ddi for default"}</span><br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketInboundCallBrandPerDdi()} onChange={(evt) => SetTicketInboundCallBrandPerDdi(evt.target.value)}/><br/>
                    <br/>                  
                </td>
            </tr>

            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Default ticket for outbound calls")}</td>
                <td width="*" valign="center">
                    {Translate("Tags")} {"(" + Translate("comma-separated") + ")"}<br/>
                    <input type="text" style={{ paddingLeft: "2px" }}  value={ZendeskGetTicketOutboundCallTag()} onChange={(evt) => { SetTicketOutboundCallTag(evt.target.value)}}/> <br/>
                    <br/>
                    {Translate("Subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketOutboundCallSubject()} onChange={(evt) => SetTicketOutboundCallSubject(evt.target.value)}/><br/>
                    {Translate("Body")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={ZendeskGetTicketOutboundCallBody()} onChange={(evt) => SetTicketOutboundCallBody(evt.target.value)}/><br/>
                    <span className="smallesttext">{Translate("Available callfields") + ": <callid> <number> <name> <extension> <callstart> <calltime> <talktime>"}</span>                   
                </td>
            </tr>
        </>
    )
}

export default EmbeddedZendeskSettings